export default {
  data() {
    return {
      allAttachments: [],
    };
  },
  methods: {
    setAllAttachments: function (attachments) {
      this.allAttachments = [...attachments];
    },
    getAllChiefComplaintAttchments: function (chiefComplaintId) {
      const params = {
        chiefComplaintId,
      };
      this.load.val = true;
      this.$store
        .dispatch('getAllAttachmentsDispatch', params)
        .then(() => {
          if (this.$store.state.chiefComplaintAttachmentModule.successFlag) {
            const data = this.$store.state.chiefComplaintAttachmentModule.allAttachments;
            this.setAllAttachments([...data].map((item) => item?.training));
          } else {
            if (this.$store.state.chiefComplaintModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.this.getAllAttchments(this.chiefComplaintId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.chiefComplaintAttachmentModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.this.getAllAttchments(this.chiefComplaintId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        })
        .finally(() => {
          this.load.val = false;
        });
    },
    addRangeOfAttachments: function () {
      const body = {
        chiefComplaintId: this.chiefComplaintId,
        trainingIds: [...this.allAttachments].map(({ id }) => id),
      };
      this.load.val = true;
      this.$store
        .dispatch('addRangeOfAttachmentsDispatch', body)
        .then(() => {
          if (this.$store.state.chiefComplaintAttachmentModule.successFlag) {
            this.showSuccessAlert('فایل های جدید پیوست شد.');
            this.cancelAttachmentModal();
          } else {
            if (this.$store.state.chiefComplaintModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.this.addRangeOfAttachments();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.chiefComplaintAttachmentModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.this.addRangeOfAttachments();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        })
        .finally(() => {
          this.load.val = false;
        });
    },
  },
};
